module.exports = __webpack_public_path__ + "img/Background_Me.a93eccfb.jpg";